import { render, staticRenderFns } from "./DUeditorEditor.vue?vue&type=template&id=76e8d060&"
import script from "./DUeditorEditor.vue?vue&type=script&lang=js&"
export * from "./DUeditorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports